module.exports = __webpack_public_path__ + "img/banner-10-1@2x.615cbbec.jpg";